import { CSSProperties } from "react";
import Flexbox from "../../../common/components/layout/Flexbox/Flexbox";
import TabletopWorkspaceToolbar from "./TabletopWorkspaceToolbar";
import TabletopWorkspaceSettingsBar from "./TabletopWorkspaceSettingsBar";

export default function TabletopWorkspaceInterface(props: {
    className?: string;
    style?: CSSProperties;
}): React.ReactElement {
    const { className, style } = props;

    return (
        <div
            className={className}
            style={{
                ...style,
                padding: style?.padding ?? 4,
                pointerEvents: style?.pointerEvents ?? "none",
            }}
        >
            <Flexbox direction="row">
                <TabletopWorkspaceToolbar />
                <div style={{ width: "100%" }}></div>
                <TabletopWorkspaceSettingsBar />
            </Flexbox>
        </div>
    );
}
